'use strict';

var React = require('react');

var SvgIncomingMajor = function SvgIncomingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.25a.75.75 0 0 1 1.5 0v3.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25h-3.5a.75.75 0 0 1 0-1.5h3.5a2.75 2.75 0 0 1 2.75 2.75v7.5a2.75 2.75 0 0 1-2.75 2.75h-7.5a2.75 2.75 0 0 1-2.75-2.75v-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.5a.75.75 0 0 1 0-1.5h2.19l-4.97-4.97a.75.75 0 0 1 1.06-1.06l4.97 4.97v-2.19a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75h-4Z"
  }));
};
SvgIncomingMajor.displayName = "IncomingMajor";

exports.SvgIncomingMajor = SvgIncomingMajor;
